import { Skeleton } from "components/ui/skeleton";

export function GlobalSettingsSkeleton() {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <Skeleton className="tw:h-96 tw:w-full tw:rounded-xl" />
      <Skeleton className="tw:h-64 tw:w-full tw:rounded-xl" />
    </div>
  );
}
